import { gql } from "@apollo/client";

export const GET_SURVEYS = gql`
  query getSurveys {
    survey {
      survey_id
      name
      org_id
      questions {
        survey_question_id
        question {
          question_id
          title
          type
          body
          order
          options {
            option_id
            order
            text
          }
        }
      }
    }
  }
`;

export const GET_SURVEY_BY_ID = gql`
  query getSurveyById($surveyId: uuid!) {
    survey_by_pk(survey_id: $surveyId) {
      survey_id
      name
      org_id
      questions {
        survey_question_id
        question {
          question_id
          title
          type
          body
          order
          options {
            option_id
            order
            text
          }
        }
      }
    }
  }
`;

export const GET_SURVEYS_BY_ORG_ID = gql`
  query getSurveysByOrgId($orgId: uuid!) {
    survey(where: { org_id: { _eq: $orgId } }) {
      survey_id
      name
      org_id
      questions {
        survey_question_id
        question {
          question_id
          title
          type
          body
          order
          options {
            option_id
            order
            text
          }
        }
      }
    }
  }
`;

export const GET_SURVEYS_WITH_NO_ORG = gql`
  query getSurveysWithNoOrg {
    survey(where: { org_id: { _is_null: true } }) {
      survey_id
      name
      org_id
      questions {
        survey_question_id
        question {
          question_id
          title
          type
          body
          order
          options {
            option_id
            order
            text
          }
        }
      }
    }
  }
`;
